import { gql, MutationHookOptions, QueryHookOptions, useMutation, useQuery } from '@apollo/client'
import { Mutation, MutationDeleteMarkupRuleArgs, MutationUpsertMarkupRulesArgs, Query } from '../gen/models'

export const MarkupRuleWithDetailFragment = gql`
  fragment MarkupRuleWithDetailFragment on MarkupRuleWithDetail {
    id
    topParentId
    facilityId
    vendor
    manufacturer
    unspsc
    unspscCommodity {
      commodity
      commodityTitle
    }
    marketBasket
    markupPercent
    topParent {
      id
      name
      facilityId
    }
    facility {
      id
      name
      facilityId
    }
    baskets {
      id
      name
    }
  }
`

export const MARKUP_RULES_QUERY = gql`
  query markupRules($pagination: Pagination) {
    markupRules(pagination: $pagination) {
      data {
        ...MarkupRuleWithDetailFragment
      }
      total
    }
  }
  ${MarkupRuleWithDetailFragment}
`

export const useMarkupRulesQuery = (options?: QueryHookOptions<Pick<Query, 'markupRules'>>) =>
  useQuery(MARKUP_RULES_QUERY, options)

export const UPSERT_MARKUP_RULES_MUTATION = gql`
  mutation upsertMarkupRules($input: [UpsertMarkupRuleInput!]!) {
    upsertMarkupRules(input: $input) {
      ...MarkupRuleWithDetailFragment
    }
  }
  ${MarkupRuleWithDetailFragment}
`

export const useUpsertMarkupRulesMutation = (
  options?: MutationHookOptions<Pick<Mutation, 'upsertMarkupRules'>, MutationUpsertMarkupRulesArgs>,
) => useMutation(UPSERT_MARKUP_RULES_MUTATION, options)

export const DELETE_MARKUP_RULE_MUTATION = gql`
  mutation deleteMarkupRule($ids: [String!]!) {
    deleteMarkupRule(ids: $ids)
  }
`

export const useDeleteMarkupRuleMutation = (
  options?: MutationHookOptions<Pick<Mutation, 'deleteMarkupRule'>, MutationDeleteMarkupRuleArgs>,
) => useMutation(DELETE_MARKUP_RULE_MUTATION, options)
